import { useCallback, useEffect, useState } from "react";
import { Maximize2, Minimize2 } from "lucide-react";
import { CameraPlayer } from "@/components/CameraPlayer";

const StatusDot = ({ status }) => (
  <span className={`status-pill ${status}`} data-testid="camera-status">
    <span className="dot" />
    {status === "live" ? "AO VIVO" : status === "offline" ? "OFFLINE" : "CONECTANDO"}
  </span>
);

export const CameraTile = ({ cam, index }) => {
  const [status, setStatus] = useState("connecting");
  const [expanded, setExpanded] = useState(false);
  const onStatus = useCallback((s) => setStatus(s), []);

  useEffect(() => {
    const esc = (e) => e.key === "Escape" && setExpanded(false);
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, []);

  return (
    <article className={`cam-tile ${expanded ? "expanded" : ""}`} style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`camera-tile-${cam.id}`}>
      <CameraPlayer cam={cam} onStatus={onStatus} />
      <div className="cam-hud">
        <span className="mono cam-index">CAM {String(index + 1).padStart(2, "0")}</span>
        <StatusDot status={status} />
      </div>
      <footer className="cam-caption">
        <div className="min-w-0">
          <h3 className="cam-name" data-testid={`camera-name-${cam.id}`}>{cam.name}</h3>
          {cam.location && <p className="cam-loc">{cam.location}</p>}
        </div>
        <button className="icon-btn" onClick={() => setExpanded((v) => !v)}
          aria-label="Expandir" data-testid={`camera-expand-${cam.id}`}>
          {expanded ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
        </button>
      </footer>
    </article>
  );
};
